import { createFileRoute } from '@tanstack/react-router'
import { CustomerChrome } from '#bv/components/customer/CustomerChrome'

export const Route = createFileRoute('/customer/balance')({
  component: CustomerBalancePage,
})

function CustomerBalancePage() {
  return (
    <CustomerChrome active="balance" title="Balance" subtitle="Your credits and transaction history.">
      <div className="rounded-2xl border border-white/[0.06] p-5 sm:p-6" style={{ background: 'rgba(10,8,16,0.8)' }}>
        <div className="flex flex-col items-center py-6 text-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-full" style={{ background: 'linear-gradient(135deg, rgba(0, 191, 255,0.08), rgba(139,92,246,0.06))' }}>
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#93c5fd" strokeWidth="1.5"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>
          </div>
          <h2 className="m-0 mt-4 text-lg font-extrabold text-[#f0f6ff]">Balance</h2>
          <p className="m-0 mt-2 max-w-[320px] text-sm text-[#5a6d8a]">
            Once we confirm your top-up provider and ledger rules, this will show your credit, top-ups, and history.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-xl border border-white/[0.06] bg-white/[0.02] px-4 py-2 text-xs font-semibold text-[#5a6d8a]">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
            Coming soon
          </div>
        </div>
      </div>

      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {[
          { title: 'Top up credits', desc: 'Add funds to your balance for faster checkout.', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="1.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>, bg: 'rgba(16,185,129,0.06)' },
          { title: 'Transaction history', desc: 'View all credits earned, spent, and top-up records.', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#a78bfa" strokeWidth="1.5"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>, bg: 'rgba(139,92,246,0.06)' },
        ].map((card) => (
          <div key={card.title} className="rounded-xl border border-white/[0.06] p-4" style={{ background: 'rgba(0,0,0,0.15)' }}>
            <div className="flex h-9 w-9 items-center justify-center rounded-lg" style={{ background: card.bg }}>
              {card.icon}
            </div>
            <p className="m-0 mt-3 text-sm font-semibold text-[#f0f6ff]">{card.title}</p>
            <p className="m-0 mt-1 text-xs text-[#5a6d8a]">{card.desc}</p>
          </div>
        ))}
      </div>
    </CustomerChrome>
  )
}
